import ApplicationAdapter from './application';

export default class SummaryPageAdapter extends ApplicationAdapter {
  pathForType() {
    return 'sign-in-field-pages';
  }
}
